<template>
  <div class="navigation">
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" v-bind:color="'primary'" app fixed dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <a class="router-link-active"><img src="../assets/logo.png" alt="DIF" height="30px" width="30px"></a>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
        <span class="font-weight-bold">Jornadas y Eventos</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="200" transition="slide-y-transition" max-width="300" bottom offset-y>
        <v-btn slot="activator" dark icon large>
          <v-icon large>account_circle</v-icon>
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img src="../assets/logo.png" alt="DIF">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ saveUsuario.nombre.toUpperCase() }}</v-list-tile-title>
                <v-list-tile-sub-title class="text-truncate">{{ saveUsuario.rol }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <div class="text-xs-center">
            <v-btn outline color="error" @click="signOut"><v-icon dark left>exit_to_app</v-icon>Cerrar sesión</v-btn>
          </div>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app>
      <v-list class="pt-2" dense>
        <v-list-tile v-for="(item, index) in items" :key="item.title" class="pa-1" @click="goTO(item.ref,index)" ripple v-bind:color="selected == index? 'secondary' : '' ">
          <v-list-tile-action>
            <v-icon v-bind:color="selected == index? 'secondary' : '' ">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <!-- <v-btn flat block color="error" class="btn-text-left" @click="signOut"><v-icon dark left>exit_to_app</v-icon>Cerrar sesión</v-btn> -->
    </v-navigation-drawer>
  </div>
</template>

<script>
import GlogalJS from '../mixins/GlobalJs';
import EventBus from '../event-bus';

export default {
  name: 'Navigation',
  mixins: [GlogalJS],
  data: () => ({
      drawer: null,
      selected: 0,
      items: [
        { title: 'JORNADAS Y EVENTOS', icon: 'assignment_ind', ref:'/eventos'},
        { title: 'REGISTRO', icon: 'people', ref:'/home'},
       // { title: 'EVENTO', icon: 'https', ref: '/evento' },
        //{ title: 'ASISTENCIA', icon: 'check_circle_', ref: '/registro' },
        { title: 'SEGUIMIENTO', icon: 'folder_open', ref: '/seguimiento' }
      ]
  }),
  mounted() {
    if(this.$router.currentRoute.path == '/beneficiarios'){
      this.selected = 1; 
    }
  },
  methods: {
    goTO(ruta,i){
      this.$router.push(ruta);
      this.selected = i;
    },
    signOut(){
      EventBus.$emit('change:SingOut');
      this.$router.replace('/login');
    },
    openDialogUsuario(){
      EventBus.$emit('change:dialogUsuario', true);
    }
  }
}
</script>

<style scoped>

</style>
